import { FC } from 'react';
import DashboardInventoryContainer from '../../dashboard-inventory/containers/DashboardInventoryContainer';
import SupplyChainContainer from '../../supply-chain/containers/SupplyChainContainer';
import ExecutiveSummaryLayout from '../components/ExecutiveSummaryLayout';
import DashboardIssuesPanelContainer from './DashboardIssuesPanelContainer';
import DetectionsContainer from './DetectionsContainer';
import ExecutiveSummaryGraphContainer from './ExecutiveSummaryGraphContainer';
import FunnelChartContainer from './FunnelChartContainer';

const ExecutiveSummaryContainer: FC = () => {
  return (
    <ExecutiveSummaryLayout
      topBar={<DashboardInventoryContainer />}
      headerLeft1={<FunnelChartContainer />}
      headerLeft2={<ExecutiveSummaryGraphContainer />}
      headerRight={<DetectionsContainer />}
      main={<SupplyChainContainer />}
      footer={<DashboardIssuesPanelContainer />}
    />
  );
};

export default ExecutiveSummaryContainer;
